import { Component, AfterViewInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Category } from '../../../classroom360/gradebook/shared/models/category.model';
import { AssignmentService } from '../assignment.service';
import { CourseSchedule } from '../../../shared-components/student/course-schedule.model';
import { GradingPeriod } from '../../../classroom360/gradebook/v10/models/grading-period.model';
import { CourseTerm } from '../../../shared-components/student/course-term.model';
import { System } from '../../../shared-components/System';

@Component({
    selector: 'app-category-weights',
    templateUrl: './category-weights.component.html'
})
export class CategoryWeightsComponent implements AfterViewInit {

    course: CourseSchedule;
    gradingPeriods: CourseTerm[];
    selectedGradingPeriod: GradingPeriod;
    allCategories: Category[];
    categories: Category[];

    constructor(
        private matDialog: MatDialogRef<CategoryWeightsComponent>,
        private assignmentService: AssignmentService
    ) {
    }

    ngAfterViewInit() {
        this.gradingPeriods = this.course.CourseTerms;
        this.assignmentService.getCategories(false, this.course.Id, '').subscribe((categories) => {
            this.allCategories = categories;
            this.categories = categories.filter(c => c.TermId == this.selectedGradingPeriod.Id);
        });
    }

    periodChanged() {
        this.categories = this.allCategories.filter(c => c.TermId == this.selectedGradingPeriod.Id);
    }

    isEven(index: number) {
        return System.isEven(index);
    }

    closeClick() {
        this.matDialog.close();
    }

}
